import React from 'react';

const Unauthorized: React.FC = () => (
  <p className="m-auto text-lg">Unauthorized</p>
);
export default Unauthorized;
